import { fetchSeries } from "services/series.service";
import SearchableSingleValueSelect from "./searchable-single-value-select";

interface SearchableSeriesSelectProps {
  value: string;
  onChange: (value: string) => void;
  isRequired?: boolean;
  disabled?: boolean;
}

const mapSeriesOption = (row: any) => ({
  label: row.title,
  value: row.id,
});

export default function SearchableSeriesSelect({
  value,
  onChange,
  isRequired = false,
  disabled = false,
}: SearchableSeriesSelectProps) {
  return (
    <SearchableSingleValueSelect
      value={value}
      onChange={onChange}
      isRequired={isRequired}
      disabled={disabled}
      labelKey="select_series"
      requiredErrorKey="field_is_required"
      fetchOptions={fetchSeries}
      mapOption={mapSeriesOption}
    />
  );
}
